module.exports = __webpack_public_path__ + "static/img/footerLogo.2e7606f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/footerLogo.png
// module id = RCsO
// module chunks = 19